@if (columnDefsDisplayed?.length) { @if (extendedData$ | async; as datas) {
<div>
  @if (datas?.length === 0) {
  <div>
    <nz-empty></nz-empty>
  </div>
  } @if (datas.length) { @let selectedDatas = selectedDatas$();
  <div fxLayout="column" fxLayoutGap="8px">
    @if ( selectedDatas?.length || hasFilters ? lessHeight() : resetHeight() ) {
    <div fxLayout="row" fxLayoutGap="4px">
      @if (selectedDatas?.length ) {
      <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="8px">
        @for (action of actionsSelectionsDisplayed2(); track action) {
        <button
          nz-button
          nzSize="small"
          nzType="default"
          nz-button
          [nzTooltipTitle]="action.tooltip"
          nz-tooltip
          [disabled]="action.disabled"
          (click)="action.action()"
          type="button"
        >
          {{ action.name }}
          @if ( action.tooltip?.length ) { y
          <span nz-icon nzType="info-circle" nzTheme="fill"></span>
          }
        </button>
        }
        <div class="mat-body-2">
          Selected rows: <b>{{ selectedDatas?.length }}</b>
        </div>
      </div>
      }
      <span fxFlex></span>
      @if (hasFilters) {
      <div>
        <button
          nz-button
          nzSize="small"
          nzType="default"
          type="button"
          (click)="resetFilters()"
        >
          Reset filters
        </button>
      </div>
      }
    </div>
    }

    <ag-grid-angular
      [scrollbarWidth]="8"
      [style.height]="displayedHeight"
      class="ag-theme-alpine ag-theme-material-custom"
      [columnDefs]="columnDefsDisplayed"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
      [animateRows]="true"
      [alwaysShowHorizontalScroll]="true"
      [groupSelectsChildren]="true"
      [rowData]="datas"
      [gridOptions]="gridOptions"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipHideDelay]="tooltipHideDelay"
      [context]="context"
      [getRowId]="getRowId"
      (sortChanged)="saveColumnState($event, 'sortChanged')"
      (columnVisible)="saveColumnState($event, 'columnVisible')"
      (dragStopped)="saveColumnState($event, 'dragStopped')"
      (filterChanged)="saveFilterState()"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (cellClicked)="onCellClicked($event)"
      [sendToClipboard]="sendToClipboard"
    ></ag-grid-angular>
    @if (legends?.length) {
    <div fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="8px">
      @for (legend of legends; track legend) {
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <div class="legend" [ngClass]="legend.class"></div>
        <div>
          <b>
            {{ legend.label }}
          </b>
        </div>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
} @else {
<nz-spin nzSimple></nz-spin>
} }
